module.exports = __webpack_public_path__ + "static/img/报警.53e2243.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/电力工程车/报警.png
// module id = Xf8p
// module chunks = 76